import React, {ReactElement, useEffect} from 'react';
import {FormattedMessage, useIntl} from 'react-intl';
import parseQueryString from '../../parseQueryString';

import advantages from '../../components/Identity/advantages';
import FormLayout from '../../components/DesignSystem/Layout/FormLayout/FormLayout';
import LoginForm from '../../components/Identity/LoginForm/LoginForm';
import SEO from '../../components/seo';
import Headers, {HeaderType} from '../../components/DesignSystem/Text/Headers/Headers';
import {Alignment} from '../../types';
import redirectByQueryParam from '../../utils/redirectByQueryParam';
import {getPageRoute} from '../../utils/routes/getPageRoute';
import {useLocale} from '../../RootProvider/LocaleContext';
import {useIdentityContext} from '../../RootProvider/IdentityContext';
import {isBrowser} from '../../browserSupport';

interface Props {
  location: {
    search: string;
  };
}

function LoginPage({location}: Props): ReactElement {
  const {formatMessage} = useIntl();
  const locale = useLocale();
  const {emailAddress} = parseQueryString(location.search);
  const {isLoggedIn} = useIdentityContext();

  const queryParams = isBrowser ? new URLSearchParams(window.location.search) : new URLSearchParams('');
  const redirectUrl = queryParams.get('r') || undefined;

  useEffect(() => {
    if (isLoggedIn) {
      redirectByQueryParam(getPageRoute('dashboard.home', locale));
    }
  }, [isLoggedIn]);

  return (
    <FormLayout advantages={advantages(formatMessage)}>
      <SEO title={formatMessage({id: 'phoenix.page.title.login'})} />
      <div className="row">
        <div className="col-xs-12">
          <Headers headerType={HeaderType.H2} alignment={Alignment.LEFT}>
            <FormattedMessage id="phoenix.login.title" />
          </Headers>
          <LoginForm emailAddress={emailAddress} redirectUrl={redirectUrl} />
        </div>
      </div>
    </FormLayout>
  );
}

export default LoginPage;
